import React from 'react'
import styles from "../Corpus/corpus.module.css"
import "../../App.css"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPenToSquare, faTrash } from '@fortawesome/free-solid-svg-icons'

export default function BattalionList({battalions, changeMilUnit, deleteBattalion}) {
  return (
    <div className={styles["corpus-list"]} onClick ={e => e.stopPropagation()}>
        <ol>
            <li className={styles["corpus-list-item"]}>
                <p className='per3 start'>Գումարտակի համար/Անվանում</p>
                <p className='per3 end'>Ղեկավարման կոճակներ</p>
            </li>
            {battalions?.map((el, index) => {
                return <li key={index} className={styles["corpus-list-item"]}>
                        <p className='per3 start'>{`${el?.battalion_number ? el?.battalion_number + " " : ""}${el?.battalion_name ? el?.battalion_name : ""}`}</p>
                        <div className='per3 end'>
                            <button className={`btn ${styles["corpus-list-item-button"]}`} onClick={() => changeMilUnit(el)}><FontAwesomeIcon icon={faPenToSquare} className={styles["edit"]} title="Խմբագրել"/></button>
                            <button className={`btn ${styles["corpus-list-item-button"]}`} onClick={() => deleteBattalion(el)}><FontAwesomeIcon icon={faTrash} className={styles["edit"]} title="Ջնջել"/></button>
                        </div>
                    </li>
            })}
        </ol>
    </div>
  )
}
